module.exports = __webpack_public_path__ + "img/text-news.c14b512d.svg";